<template>
    <div>
        <el-table
                :data="secondData"
                border
                stripe
                style="width: 100%"
                :default-sort="{prop: 'startTime', order: 'descending'}"
        >
            <el-table-column
                    property="rowindex"
                    label="序号"
                    width="60px"
            >
            </el-table-column>
            <el-table-column
                    property="store_name"
                    label="门店"
                    sortable
                    min-width="210"
            >
            </el-table-column>

            <el-table-column
                    property="address"
                    label="地址"
                    sortable
                    min-width="210"
            >
            </el-table-column>

            <el-table-column
                    property="title"
                    label="标题"
                    sortable
                    min-width="210"
            >
            </el-table-column>
            <el-table-column
                    property="alias"
                    label="服务人员"
                    sortable
                    min-width="210"
            >
            </el-table-column>
            <el-table-column
                    property="status"
                    label="最新状态"
                    sortable
                    min-width="210"
            >
                <template slot-scope="scope">
                    <!--<span style="color: orange">{{scope.row.status}}</span>-->
                <!--</template>-->
                <span v-if="scope.row.status=='NEW'"
                style="color:red">尚未派单</span>
                <span v-else-if="scope.row.status=='DISPATCHED'"
                style="color:orange">等待接单</span>
                <span v-else-if="scope.row.status=='REFUSED'"
                style="color:orange">拒绝接单</span>
                <span v-else-if="scope.row.status=='ACCEPTED'"
                style="color:orange">确认接单</span>
                <span v-else-if="scope.row.status=='VACANT_ORDER'"
                style="color:orange">无人接单</span>
                <span v-else-if="scope.row.status=='LIST_UNCONFIRMED'"
                style="color:orange">服务清单确认中</span>
                <span v-else-if="scope.row.status=='LIST_CONFIRMED'"
                style="color:orange">服务清单已确认</span>
                <span v-else-if="scope.row.status=='LIST_REJECTED'"
                style="color:orange">服务清单被退回</span>
                <span v-else-if="scope.row.status=='QUOTATION_UNCONFIRMED'"
                style="color:orange">报价单确认中</span>
                <span v-else-if="scope.row.status=='QUOTATION_CONFIRMED'"
                style="color:orange">报价单已确认</span>
                <span v-else-if="scope.row.status=='QUOTATION_REJECTED'"
                style="color:orange">报价单被退回</span>
                <span v-else-if="scope.row.status=='REPORT_UNCONFIRMED'"
                style="color:orange">完工单确认中</span>
                <span v-else-if="scope.row.status=='REPORT_CONFIRMED'"
                style="color:orange">完工单已确认</span>
                <span v-else-if="scope.row.status=='REPORT_REJECTED'"
                style="color:orange">完工单被退回</span>
                <span v-else-if="scope.row.status=='COMPLETED'"
                style="color:orange">已完成</span>
                <span v-else-if="scope.row.status=='CLOSED'"
                style="color:orange">已关闭</span>
                <span v-else-if="scope.row.status=='SERVICE_REFUSED'"
                style="color:orange">客服拒绝此工单</span></template>
            </el-table-column>
            <el-table-column
                    fixed="right" label="操作"
                    width="80"
            >
                <template slot-scope="scope">
                    <el-button
                            type="warning" size="small"
                            @click="info(scope.$index, scope.row)">详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {

        },
        components: {
        },
        data() {
            return {
                secondData : [],
            }
        },
        computed: {},
        created() {
        },
        methods: {
            getData(data) {
                this.secondData = data
            },
            info(index, row) {
                this.$router.push({
                    path: '/workOrderInfo',
                    query: {
                        ticket_id: row.ticket_id,
                        store_name: row.store_name,
                        address: row.address
                    }
                })
            },
        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';

    
</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/tableList/secondTable.vue